import { useQuery } from '@tanstack/react-query';

import { _getSingleEntityOptions } from '@/api/entity/queries';
import { entityApprovalStatus } from '@/api/entity/types';
import { useSelectedUserConfigSlice } from '@/stores/selectors';

export const useDealProviderPermissions = () => {
  const { selectedEntityId, selectedUserRole } = useSelectedUserConfigSlice();
  const isAdmin = selectedUserRole === 'admin';
  const isEntity = selectedUserRole === 'entity';

  const {
    data: currentEntity,
    isLoading,
    isError,
  } = useQuery({
    ..._getSingleEntityOptions(selectedEntityId),
    enabled: isEntity && !!selectedEntityId,
  });

  const isEntityApproved = currentEntity?.entityApprovalStatus === entityApprovalStatus.Verified;
  const isProviderAuthorised = currentEntity?.isProvider;

  const isCreateCompanyDisabled =
    !isAdmin && (!currentEntity || !isEntityApproved || !isProviderAuthorised);

  const createCompanyTooltip = !isEntityApproved
    ? 'Entity has to be approved'
    : !isProviderAuthorised
      ? 'Entity has to be authorised as a provider'
      : '';
  const isOfferCreationDisabled =
    isEntity &&
    (isError || (!isLoading && (!currentEntity || !isEntityApproved || !isProviderAuthorised)));
  const offerCreationTooltip = !isEntityApproved
    ? 'Entity has to be approved'
    : 'Entity has to be authorised as a provider';

  return {
    isEntityApproved,
    isProviderAuthorised,
    isCreateCompanyDisabled,
    createCompanyTooltip,
    isOfferCreationDisabled,
    offerCreationTooltip,
    isEntityStatusLoading: isEntity && isLoading,
    /** False (not perpetually loading) whenever the entity query is disabled — i.e. any non-entity session */
    isLoading,
  };
};
